import styled, { keyframes, createGlobalStyle } from 'styled-components';

// Animations
export const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const float = keyframes`
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
`;

export const pulse = keyframes`
  0%, 100% {
    opacity: 0.8;
  }
  50% {
    opacity: 1;
  }
`;

export const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

// Background Elements
export const BackgroundElementServices = styled.div`
  position: absolute;
  border-radius: 50%;
  filter: blur(100px);
  opacity: 0.1;
  pointer-events: none;
  animation: ${float} 6s ease-in-out infinite;

  &.red-1 {
    width: 300px;
    height: 300px;
    background: radial-gradient(circle, #ff4757, #ff3742);
    top: 60%;
    left: 10%;
    animation-delay: 0s;
  }

  &.blue-1 {
    width: 400px;
    height: 400px;
    background: radial-gradient(circle, #3742fa, #2f3542);
    top: 80%;
    right: 15%;
    animation-delay: 2s;
  }

  &.red-2 {
    width: 250px;
    height: 250px;
    background: radial-gradient(circle, #ff6b7a, #ff4757);
    bottom: 30%;
    left: 20%;
    animation-delay: 4s;
  }

  &.blue-2 {
    width: 350px;
    height: 350px;
    background: radial-gradient(circle, #5352ed, #3742fa);
    bottom: 10%;
    right: 10%;
    animation-delay: 1s;
  }
`;

export const BackgroundElement = styled.div`
  position: absolute;
  border-radius: 50%;
  filter: blur(100px);
  opacity: 0.1;
  pointer-events: none;
  animation: ${float} 6s ease-in-out infinite;

  &.red-1 {
    width: 300px;
    height: 300px;
    background: radial-gradient(circle, #ff4757, #ff3742);
    top: 10%;
    left: 10%;
    animation-delay: 0s;
  }

  &.blue-1 {
    width: 400px;
    height: 400px;
    background: radial-gradient(circle, #3742fa, #2f3542);
    top: 20%;
    right: 15%;
    animation-delay: 2s;
  }

  &.red-2 {
    width: 250px;
    height: 250px;
    background: radial-gradient(circle, #ff6b7a, #ff4757);
    bottom: 30%;
    left: 20%;
    animation-delay: 4s;
  }

  &.blue-2 {
    width: 350px;
    height: 350px;
    background: radial-gradient(circle, #5352ed, #3742fa);
    bottom: 10%;
    right: 10%;
    animation-delay: 1s;
  }
`;
